import { GetComponentStyleFunc } from './types';

export const muiTab: GetComponentStyleFunc<'MuiTab'> = theme => {
  return {
    styleOverrides: {
      root: {
        textTransform: 'none',
        flex: 1,
        margin: 0.5,
        fontSize: '18px',
        fontWeight: 600,
        height: '48px',
        borderRadius: '24px',
        minHeight: '40px',
        color: theme.colors.functional.text.second,
        '&.Mui-selected': {
          color: theme.colors.functional.text.primary,
          background: theme.colors.functional.container.primary,
        },
      },
    },
  };
};

export const muiTabs: GetComponentStyleFunc<'MuiTabs'> = theme => {
  return {
    styleOverrides: {
      root: {
        borderRadius: '28px',
        width: '100%',
        '.MuiTabs-indicator': {
          display: 'none',
        },
        display: 'flex',
        padding: '4px',
        marginBottom: '0px',
        background: theme.colors.functional.container.dark,
      },
    },
  };
};
